import flow from 'lodash/flow'
import identity from 'lodash/identity'
import moment from 'moment'

import fork from './fork'

const toMoment = fork(identity, flow(Number, moment), () => null)

export default toMoment
